import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaYoutube,
  
} from "react-icons/fa";
import "./Footer.scss";

import logo from "../../assets/logo.jpeg";
import cpmy from "../../data/cmy";
import cmpy from "../../data/cmy";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo + Description */}
        <div className="footer-section about">
          <div className="footer-logo">
            <Link to="/">
              <img src={logo} alt="Logo" />
            </Link>
          </div>
          <p>We convert visions into celebrations - every time..</p>
          <div className="social-icons">
            <a href="#">
              <FaFacebookF />
            </a>
            <a 
  href="https://www.instagram.com/jm_tech_solutions_2024/"
  target="_blank"
  rel="noopener noreferrer"
>
  <FaInstagram />
</a>
            {/* <a href="jmtechsolution2024@gmail.com"><FaEnvelope /></a> */}

            {/* it will be take only mail id */}
            {/* <a href="mailto:jmtechsolution2024@gmail.com?subject=Project Inquiry&body=Hello, I am interested in your services."><FaEnvelope /></a> */}

            {/* it will be take only mail id and subject and body also*/}
            <a
              href="https://mail.google.com/mail/?view=cm&fs=1&to=jmtechsolution2024@gmail.com&su=Project%20Inquiry&body=Hello%2C%20I%20am%20interested%20in%20your%20services."
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaEnvelope />
            </a>
            <a href="#">
              <FaYoutube />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section links">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/ServicesPage">Services</Link>
            </li>
            <li>
              <Link to="/gallary">Gallary</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-section services">
          <h3>Our Services</h3>
          <ul>
            <li>
              <Link to="/ServicesPage">Support Services</Link>
            </li>
            {/* <li><Link to="/production">Production</Link></li>
            <li><Link to="/management">Management</Link></li>
            <li><Link to="/promotion">Promotion</Link></li> */}
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section contact">
          <h3>Contact Us</h3>
          <p>
            <FaMapMarkerAlt /> {cmpy.address}
          </p>
          <p>
            <FaPhoneAlt /> {cpmy.mobile}
          </p>
          <p>
            <FaEnvelope /> {cpmy.mail}
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} {cpmy.name} All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
